<template>
  <v-dialog scrollable max-width="800px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <v-btn small color="info" v-on="on">Resumen de pagos</v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title>
        <h4>Resumen</h4>
      </v-card-title>
      <v-card-text>
        <v-col cols="12">
          <GeneracionAutocomplete
            ref="asig"
            :filtroEstado="['Cerrado']"
            @generacionId="setGeneracionId"
          />
        </v-col>
        <v-container class="y5">
          <v-layout row wrap>
            <v-row class="md12 sx12 sx12 lg12 xl12 " no-gutters>
              <h3>Pendientes</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Descripcion</th>
                      <th class="text-right">Cantidad</th>
                      <th class="text-right">Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="pendiente in pendientes"
                      :key="pendiente.descripcion"
                    >
                      <td>{{ pendiente.descripcion }}</td>
                      <td class="text-right">
                        {{ pendiente.cantidad | numberFormat }}
                      </td>
                      <td class="text-right">
                        {{ pendiente.monto | numberFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td class="text-right font-weight-bold">
                        {{ totalPendiente | numberFormat }}
                      </td>
                      <td class="text-right font-weight-bold">
                        {{ totalPendienteMonto | numberFormat }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-row>
            <v-row class="md12 sx12 sx12 lg12 xl12 " no-gutters>
              <h3>Pagados</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Descripcion</th>
                      <th class="text-right">Cantidad</th>
                      <th class="text-right">Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="pagado in pagados" :key="pagado.descripcion">
                      <td>{{ pagado.descripcion }}</td>
                      <td class="text-right">
                        {{ pagado.cantidad | numberFormat }}
                      </td>
                      <td class="text-right">
                        {{ pagado.monto | numberFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td class="text-right font-weight-bold">
                        {{ totalPagado | numberFormat }}
                      </td>
                      <td class="text-right font-weight-bold">
                        {{ totalPagadoMonto | numberFormat }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-row>
            <v-row class="md12 sx12 sx12 lg12 xl12 " no-gutters>
              <h3>Pagados</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Descripcion</th>
                      <th class="text-right">Cantidad</th>
                      <th class="text-right">Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="pendiente in pagados2"
                      :key="pendiente.descripcion"
                    >
                      <td>{{ pendiente.descripcion }}</td>
                      <td class="text-right">
                        {{ pendiente.cantidad | numberFormat }}
                      </td>
                      <td class="text-right">
                        {{ pendiente.monto | numberFormat }}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td class="text-right font-weight-bold">
                        {{ totalPagado | numberFormat }}
                      </td>
                      <td class="text-right font-weight-bold">
                        {{ totalPagadoMonto | numberFormat }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-row>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="showDialog = false">Volver</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import numeral from "numeral";
import GeneracionAutocomplete from "@/components/shared/GeneracionAutocomplete.vue";


export default {
  components: {
    GeneracionAutocomplete
  },
  data() {
    return {
      showDialog: false,
      pagados: [],
      pagados2: [],
      pendientes: []
    };
  },
  methods: {
    
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    setGeneracionId(id) {
      console.log(id)
      this.pagados = [];
      this.pagados2 = [];
      this.pendientes = [];
      this.getData(id)
    },
    getData(generacionId) {
      axios
        .get("/pago/resumen/pagados/"+generacionId)
        .then(response => {
          this.pagados = response.data;
        })
        .catch(err => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });

      axios
        .get("/pago/resumen/pendientes/"+generacionId)
        .then(response => {
          this.pendientes = response.data;
        })
        .catch(err => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
      axios
        .get("/pago/resumen/pagados2/"+generacionId)
        .then(response => {
          this.pagados2 = response.data;
        })
        .catch(err => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    }
  },
  mounted() {
    // if (!numeral.locale) {
    // }
  },
  computed: {
    totalPagado() {
      if (this.pagados.length > 0) {
        return this.pagados.reduce((a, b) => a + b.cantidad, 0);
      }
      return 0;
    },
    totalPagadoMonto() {
      if (this.pagados.length > 0) {
        return this.pagados.reduce((a, b) => a + b.monto, 0);
      }
      return 0;
    },
    totalPendienteMonto() {
      if (this.pendientes.length > 0) {
        return this.pendientes.reduce((a, b) => a + b.monto, 0);
      }
      return 0;
    },
    totalPendiente() {
      if (this.pendientes.length > 0) {
        return this.pendientes.reduce((a, b) => a + b.cantidad, 0);
      }
      return 0;
    }
  },
  filters: {
    numberFormat(value) {
      if (value) {
        return numeral(value).format("#,##0"); // displaying other groupings/separators is possible, look at the docs
      }
    }
  },
  watch: {
    showDialog: function(val) {
      if (!val) {
        return;
      }
    }
  }
};
</script>
